import { api } from "@api/api";
import { masks } from "@core/utils/masks";
import { Plan } from "@modules/plans/types";
import { PlanFormValues } from "@modules/plans/validations";

export async function createPlanService(data: PlanFormValues): Promise<Plan> {
  if (data.value) {
    const unmaskedValue = Number(masks.unmask(data.value));
    data.value = (unmaskedValue / 100).toFixed(2);
  }

  const { data: plan } = await api.post<Plan>("v1/subscription_plan_admin/", data);

  return plan;
}
